// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"Modal_modalBackdrop__CRKl4","modalContent":"Modal_modalContent__B5j1-","modalClose":"Modal_modalClose__FLpie","modalBody":"Modal_modalBody__I0kWW"};